export enum SmsTemplateCode {
  MOBILE_CONFIRMATION = 'MOBILE_CONFIRMATION',
  TEMPORARY_PASSWORD = 'TEMPORARY_PASSWORD',
  BLANK = 'BLANK',
  LEGAL_PROCEEDING_REMINDER = 'LEGAL_PROCEEDING_REMINDER',
  PAYMENT_INSTRUCTIONS_BANK = 'PAYMENT_INSTRUCTIONS_BANK',
  PAYMENT_INSTRUCTIONS_EASYPAY = 'PAYMENT_INSTRUCTIONS_EASYPAY',
}
